import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import Article from "supportbeacon/article";
import { RelevantArticle } from "supportbeacon/model";
import { getRelevantArticles, getTranslation } from "utilities/articleUtils";

interface SupportSidePanelDetailsProps {
  article: server.dto.Article
}

export const SupportSidePanelDetails = (props: SupportSidePanelDetailsProps) => {
  const article = props.article;

  const translation = getTranslation(article.translations);
  const relevantArticles: RelevantArticle[] = getRelevantArticles(article);
  const contentEl = () => <div dangerouslySetInnerHTML={{ __html: translation.content }}></div>;

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[]}
    additionalContent={<>
      <div className="nav-text-semibold">{translation.title}</div>
      <Article
        inSidePanel
        renderContent={contentEl}
        relevantArticles={relevantArticles}
      />
    </>}
  />
}